import { ViewOption } from 'shared/types/ViewOption';
import { TABLE, TIME_SERIES } from 'shared/constants/viewOptions';

export const VALUES_TAB = 'Values';
export const FACTORS_TAB = 'Factors';
export const LEVEL_TAB = 'Level';
export const RETURN_TAB = 'Return';

export const MARKET_DATA_VIEW_OPTION_LIST: ViewOption[] = [
  {
    value: TIME_SERIES,
    iconSrc: 'TimeSeries',
  },
  {
    value: TABLE,
    iconSrc: 'Table',
  },
];

export const DEFAULT_DATA = {
  timeseries: {
    factor: '',
    assetClass: '',
    timeSeriesData: [],
  },
};
